import { type ComponentClass } from 'preact';
import _ReactDiffViewer, { DiffMethod, type ReactDiffViewerProps, type ReactDiffViewerState } from 'react-diff-viewer';

// Annoying type incompatibility between Preact and React…
const ReactDiffViewer = _ReactDiffViewer as unknown as ComponentClass<ReactDiffViewerProps, ReactDiffViewerState>;

export { DiffMethod, ReactDiffViewer };
